import { render, staticRenderFns } from "./reportCustomersList.vue?vue&type=template&id=c93c9b5a&"
import script from "./reportCustomersList.vue?vue&type=script&lang=js&"
export * from "./reportCustomersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports